import React from "react";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
import SimpleNegativeChart from "../../charts/barWithNegatives/SimpleNegativeChart";
import CircularProgress from "@mui/material/CircularProgress";

const CamSingleBarChartLargeCard = ({
  title,
  suffix,
  data,
  cardInfoLoader,
  Icon,
}) => {
  return (
    <div className="flex flex-col p-2 bg-white shadow-xl h-full w-full rounded-xl">
      <div className="flex">
      <div className="w-[35px] h-[24px] object-contain">
        {typeof Icon === "string" ? (
          <img src={Icon} className="w-full h-full" alt="svg" />
        ) : (
          <Icon sx={{ width: "100%" }} />
        )}
      </div>
      <h2 className="text-xl font-medium text-left font-Roboto">{title}</h2>
      </div>
      {cardInfoLoader ? (
        <CircularProgress color="secondary" />
      ) : (
        <div className="flex items-center justify-center gap-3">
          <h3 className="text-3xl font-bold font-Roboto">
            {Number(data.total).toLocaleString() + suffix}
          </h3>
        </div>
      )}
      <div className="flex flex-row">
        {cardInfoLoader ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className="w-full flex items-center h-10 justify-between">
            <ManIcon />
            <SimpleNegativeChart
              watchersData={{
                man: data.man,
                woman: data.woman,
              }}
              width={100}
            />
            <WomanIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default CamSingleBarChartLargeCard;
